export default {"src":"/_next/static/media/academicLogo3.87fbe727.svg","height":48,"width":163,"blurWidth":0,"blurHeight":0};